(function () {
  'use strict';
  function start(root = document) {
    const header = root.querySelector('[data-header]');
    if (!header || header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';
    const menus = Array.from(header.querySelectorAll('[data-mega]'));
    const desktop = matchMedia('(min-width:761px)');
    const shade = document.createElement('button');
    shade.type = 'button'; shade.className = 'navigation-shade'; shade.hidden = true;
    shade.setAttribute('aria-label', header.dataset.closeLabel);
    shade.tabIndex = -1; header.append(shade);
    let pending;
    const sync = () => {
      const opened = menus.some(menu => menu.open);
      shade.hidden = !opened || !desktop.matches;
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      header.style.setProperty('--navigation-top', bottom + 'px');
    };
    const close = restore => {
      clearTimeout(pending);
      menus.forEach(menu => {
        if (menu.open && restore) menu.querySelector('summary').focus();
        menu.open = false;
      }); sync();
    };
    menus.forEach((menu, menuIndex) => {
      let openedByHover = false;
      menu.querySelector('summary').addEventListener('click', event => {
        if (event.detail > 0 && openedByHover && !event.target.closest('a')) event.preventDefault();
        openedByHover = false;
      });
      const columns = menu.querySelector('.mega-columns');
      if (!columns) return;
      const groups = Array.from(columns.children).filter(el => el.tagName === 'DIV' && el.querySelector('h3'));
      const featured = Array.from(columns.children).filter(el => el.classList.contains('mega-image'));
      const rail = document.createElement('div'); rail.className = 'navigation-rail';
      const branches = document.createElement('div'); branches.className = 'navigation-branches';
      const buttons = [];
      const activate = (index, focus = false) => {
        groups.forEach((group, i) => { group.hidden = i !== index; buttons[i].setAttribute('aria-expanded', String(i === index)); });
        branches.hidden = index < 0;
        if (focus && index >= 0) groups[index].querySelector('a')?.focus();
      };
      groups.forEach((group, index) => {
        group.id = 'NavigationBranch-' + menuIndex + '-' + index;
        group.classList.add('navigation-branch');
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'navigation-trigger';
        button.textContent = group.querySelector('h3').textContent;
        button.setAttribute('aria-controls', group.id); button.setAttribute('aria-expanded', 'false');
        const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.setAttribute('aria-hidden', 'true'); button.append(arrow);
        button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') activate(index); });
        button.addEventListener('focus', () => activate(index));
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); activate(index, true); }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault(); buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + groups.length) % groups.length].focus();
          }
        });
        group.addEventListener('keydown', event => { if (event.key === 'ArrowLeft') { event.preventDefault(); buttons[index].focus(); } });
        buttons.push(button); rail.append(button); branches.append(group);
      });
      const campaigns = document.createElement('div'); campaigns.className = 'navigation-campaigns';
      featured.forEach(tile => campaigns.append(tile)); rail.append(campaigns);
      columns.replaceChildren(rail, branches); columns.classList.add('navigation-columns'); activate(-1);
      menu.addEventListener('pointerenter', event => {
        clearTimeout(pending);
        if (event.pointerType === 'mouse' && desktop.matches) { openedByHover = !menu.open; menus.forEach(other => other.open = other === menu); sync(); }
      });
      menu.addEventListener('pointerleave', () => {
        pending = setTimeout(() => { if (!menu.contains(document.activeElement)) { menu.open = false; sync(); } }, 180);
      });
      menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) { menu.open = false; sync(); } });
      menu.addEventListener('toggle', () => {
        if (menu.open) menus.filter(other => other !== menu).forEach(other => other.open = false);
        else activate(-1);
        sync();
      });
    });
    shade.addEventListener('click', () => close(true));
    document.addEventListener('click', event => { if (!event.target.closest('[data-mega]')) close(false); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') close(true); });
    document.addEventListener('motion:dialog', () => close(false));
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync); desktop.addEventListener('change', () => close(false));
    sync();
  }
  start(); document.addEventListener('shopify:section:load', event => start(event.target));
})();
